import { get, cloneDeep } from 'lodash';
import { notification } from 'antd';
import interceptors from 'common/interceptors';
import authRedirect from '@/common/help/auth-redirect';

export const API_SERVER = {
  development: 'https://aosp-gateway.beta.saybot.net',
  staging: 'https://aosp-gateway.staging.saybot.net',
  alpha: 'https://aosp-gateway.beta.saybot.net',
  beta: 'https://aosp-gateway.beta.saybot.net',
  production: 'https://aosp-gateway.alo7.com',
};

const TAMIC_SERVER = {
  development: 'https://tamic.alpha.saybot.net',
  staging: 'https://tamic.staging.saybot.net',
  alpha: 'https://tamic.alpha.saybot.net',
  beta: 'https://tamic.beta.saybot.net',
  production: 'https://tamic.alo7.com',
};

const SANDBOX_SERVER = {
  development: 'http://sandbox-h5.alo7.com/pb/pb_admin_client/#/myQuestionLibrary',
  beta: 'http://sandbox-h5.alo7.com/pb/pb_admin_client/#/myQuestionLibrary',
  staging: '',
  production: 'https://www.alo7.com/app/pb_admin_client/index.html#/myQuestionLibrary',
};

const ACME_SERVER = {
  development: 'https://aosp-operation-frontend-internal.beta.saybot.net',
  staging: 'https://aosp-operation-frontend-internal.staging.saybot.net',
  alpha: 'https://aosp-operation-frontend-internal.alpha.saybot.net',
  beta: 'https://aosp-operation-frontend-internal.beta.saybot.net',
  production: 'https://aosp.alo7.com',
};

const HOME_NG_HOST = {
  development: 'https://homework-ng.beta.saybot.net',
  staging: '',
  alpha: '',
  beta: 'https://homework-ng.beta.saybot.net',
  production: 'https://homework-ng.alo7.com',
};
const AI_SERVER = {
  development: 'https://aigc.beta.saybot.net',
  staging: '',
  alpha: '',
  beta: 'https://aigc.beta.saybot.net',
  production: '',
};

const TRAIN_EAR_HOST = {
  development: 'https://studycenter-beta-ali.saybot.net',
  staging: '',
  alpha: '',
  beta: 'https://studycenter-beta-ali.saybot.net',
  production: 'https://studycenter-prod.alo7.com',
};

const nxInterceptor = new nx.Interceptor({ async: false, items: interceptors });
const DEFAULT_OPTIONS = { timeout: 15000 };
const _alo7Api = {
  notified: false,
  prefix: {
    host: API_SERVER[process.env.NODE_ENV] + '/ace-kellis',
    tamic: TAMIC_SERVER[process.env.NODE_ENV],
    sandbox: SANDBOX_SERVER[process.env.NODE_ENV],
    acme: ACME_SERVER[process.env.NODE_ENV],
    homeworkng: HOME_NG_HOST[process.env.NODE_ENV],
    aiServer: AI_SERVER[process.env.NODE_ENV],
    trainEar: TRAIN_EAR_HOST[process.env.NODE_ENV],
  },
  fetch(inUrl: RequestInfo, inOptions?: RequestInitOptions) {
    const reqOptions = nxInterceptor.compose(
      { url: inUrl, ...DEFAULT_OPTIONS, ...inOptions },
      'request'
    );
    const { url, ...init } = reqOptions;
    const input = url;
    const requestParams = init ? cloneDeep(init) : {};
    const headers = cloneDeep(requestParams).headers || {};
    const { token } = alo7Account;

    if (!(inUrl as string).includes('/authentication') && !token) {
      !this.notified &&
        notification.info({
          message: '入口转移',
          description: '请到[AOSP/教研中心]进入Kellis',
          duration: null,
        });
      this.notified = true;
      return Promise.reject(null);
    }

    // 如果headers里的content-type没有指定, 默认设为application/json
    if (!requestParams.headers || !requestParams.headers['Content-Type'])
      Object.assign(headers, { 'Content-Type': 'application/json' });
    Object.assign(requestParams, { headers });

    // 如果传入的haders里的content-type指定为auto, 那就删掉content-type, 让浏览器自动去指定
    if (requestParams.headers && requestParams.headers['Content-Type'] === 'auto')
      delete requestParams.headers['Content-Type'];

    return new Promise((resolve, reject) => {
      // 设置超时
      const timeId = setTimeout(() => {
        const timeoutError = new Error();
        timeoutError.message = '请求超时';
        reject(timeoutError);
      }, requestParams.timeout);

      window
        .fetch(input, {
          ...requestParams,
        })
        .then(res => {
          if (res.status === 401) return authRedirect();
          clearTimeout(timeId);
          if (res.status >= 200 && res.status < 300) {
            res
              .clone()
              .json()
              .then(result => {
                const resOptions = nxInterceptor.compose(
                  { meta: reqOptions, data: result },
                  'response'
                );
                const response = resOptions.data;
                resolve(response);
              })
              .catch(() => {
                res
                  .clone()
                  .blob()
                  .then(blob => resolve(blob))
                  .catch(() => resolve({}));
              });
          } else {
            res.json().then(response => {
              const code = get(response, 'errors[0].code');
              if (code === 'session.expired') {
                nx.$message.post('token-expired', true);
              }
              // const error = new Error();
              const error = { message: '' };
              const message: string = get(response, 'errors[0].detail', '');
              error.message = message.length > 30 ? message.substring(0, 30) + '...' : message;
              reject({ ...get(response, 'errors[0]', {}), ...error });
            });
          }
        })
        .catch(err => {
          // window.dispatchEvent(Alo7LoadingToFalse);
          clearTimeout(timeId);
          reject(err);
        });
    });
  },
};

window.alo7Api = _alo7Api;
